import { useState } from 'react';
import { Link, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { RefundList } from './components/refund-list';
import { HowRefundWorksDialog } from '@/components/partial/how-refund-works-dialog';
import { HIDE_REFUND_INFO_KEY } from '@/constants/subsidy/local-storage';
import { PageContainer } from '@/components/shared/page-container';
import { PageHeader } from '@/components/shared/page-header';
import { usePoliciesIndex } from '@/data/subsidy/policies';
import { useSetTitle } from '@/hooks/use-set-title';

export const Subsidy = () => {
  useSetTitle('Meus reembolsos');
  const navigate = useNavigate();
  const { policies } = usePoliciesIndex();
  const [showDismissCheckbox, setShowDismissCheckbox] = useState(false);
  const [openHowRefundWorksDialog, setOpenHowRefundWorksDialog] =
    useState(false);

  const handleNewRefund = () => {
    const bypassOpen = !!localStorage.getItem(HIDE_REFUND_INFO_KEY);
    if (bypassOpen) {
      navigate('/meus-reembolsos/novo');
    } else {
      setOpenHowRefundWorksDialog(true);
      setShowDismissCheckbox(true);
    }
  };

  const handleHowRefundWorks = () => {
    setShowDismissCheckbox(false);
    setOpenHowRefundWorksDialog(true);
  };

  return (
    <PageContainer>
      <PageHeader
        title="Reembolso"
        description={
          <Typography mt={1}>
            Crie e gerencie solicitações de reembolso.{' '}
            <Link onClick={handleHowRefundWorks} color="info.main">
              Veja como funciona
            </Link>
          </Typography>
        }
        buttonText="Novo reembolso"
        buttonOnClick={handleNewRefund}
        buttonDisabled={!policies?.length}
      />
      <RefundList />
      {openHowRefundWorksDialog && (
        <HowRefundWorksDialog
          showDismissCheckbox={showDismissCheckbox}
          onClose={() => setOpenHowRefundWorksDialog(false)}
        />
      )}
    </PageContainer>
  );
};
